<template>
  <div class="dashboard-page animate-[fadeIn_0.6s_ease-out]">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="page-icon">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
        </svg>
      </div>
      <div>
        <h3 class="page-title">数据看板</h3>
        <p class="page-subtitle">系统核心数据统计与趋势分析</p>
      </div>
    </div>

    <!-- 前台关联提示 -->
    <div class="front-hint">
      <svg class="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <div>
        <p class="front-hint-title">前台关联</p>
        <p class="front-hint-desc">数据看板汇总前台用户行为数据，用于运营分析和内容策略调整</p>
      </div>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon" style="background: linear-gradient(135deg, #BFDBFE, #93C5FD);">
          <svg class="w-6 h-6" style="color: #1E40AF;" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ experts.length }}</div>
          <div class="stat-label">专家总数</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon" style="background: linear-gradient(135deg, #D1FAE5, #A7F3D0);">
          <svg class="w-6 h-6" style="color: #065F46;" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ activeExpertCount }}</div>
          <div class="stat-label">活跃专家</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon" style="background: linear-gradient(135deg, #FEF3C7, #FDE68A);">
          <svg class="w-6 h-6" style="color: #92400E;" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ caseCount }}</div>
          <div class="stat-label">案例总数</div>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon" style="background: linear-gradient(135deg, #E9D5FF, #C4B5FD);">
          <svg class="w-6 h-6" style="color: #6B21A8;" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ topicCount }}</div>
          <div class="stat-label">话题总数</div>
        </div>
      </div>
    </div>

    <!-- 下方两栏 -->
    <div class="charts-grid">
      <!-- 专家积分排行 -->
      <div class="chart-card">
        <div class="chart-header">
          <svg class="w-4 h-4 text-[#F2C94C]" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <h4 class="chart-title">专家积分排行 TOP5</h4>
        </div>
        <el-table :data="topExperts" size="small" style="width: 100%">
          <el-table-column prop="rank" label="排名" width="60" />
          <el-table-column prop="name" label="姓名" width="100" />
          <el-table-column prop="title" label="头衔" />
          <el-table-column prop="points" label="积分" width="100" align="right">
            <template #default="{ row }">
              <span class="font-bold text-[#F2C94C]">{{ row.points }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 用户学习概览 -->
      <div class="chart-card">
        <div class="chart-header">
          <svg class="w-4 h-4 text-[#F2C94C]" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h4 class="chart-title">用户学习概览</h4>
        </div>
        <div class="stat-list">
          <div class="stat-row">
            <span class="stat-row-label">学习总时长</span>
            <span class="stat-row-value">{{ totalStudyDuration }} 分钟</span>
          </div>
          <div class="stat-row">
            <span class="stat-row-label">练习正确率</span>
            <span class="stat-row-value">{{ practiceAccuracy }}%</span>
          </div>
          <div class="stat-row">
            <span class="stat-row-label">学习记录数</span>
            <span class="stat-row-value">{{ studyRecords.length }} 条</span>
          </div>
          <div class="stat-row">
            <span class="stat-row-label">练习记录数</span>
            <span class="stat-row-value">{{ practiceRecords.length }} 条</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { TOPICS } from '../../data'
import { EXPERT_CASES } from '../../data/cases'

export default {
  name: 'DashboardPage',

  computed: {
    ...mapState(['experts', 'studyRecords', 'practiceRecords']),
    ...mapGetters(['expertLeaderboard', 'activeExpertCount', 'totalStudyDuration', 'practiceAccuracy']),

    topExperts() {
      return this.expertLeaderboard.slice(0, 5).map((e, i) => ({ ...e, rank: i + 1 }))
    },

    caseCount() {
      return Object.keys(EXPERT_CASES).length
    },

    topicCount() {
      return TOPICS.length
    },
  },
}
</script>

<style scoped>
.dashboard-page {
  max-width: 1200px;
  margin: 0 auto;
}

/* 页面标题 */
.page-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.page-icon {
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, #F5D76E, #F2C94C);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1B3C59;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(242, 201, 76, 0.25);
}

.page-title {
  font-size: 22px;
  font-weight: 800;
  color: #0F172A;
  margin: 0;
  line-height: 1.2;
}

.page-subtitle {
  font-size: 13px;
  color: #94A3B8;
  margin: 4px 0 0 0;
}

/* 前台关联提示 */
.front-hint {
  background: rgba(239, 246, 255, 0.8);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(219, 234, 254, 0.6);
  border-radius: 20px;
  padding: 16px 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
  color: #1E40AF;
}

.front-hint svg {
  color: #3B82F6;
  margin-top: 2px;
}

.front-hint-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
  color: #1E3A8A;
}

.front-hint-desc {
  font-size: 13px;
  color: #3B82F6;
  margin: 0;
  line-height: 1.5;
}

/* 统计卡片 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 24px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 24px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 1px 3px rgba(27, 60, 89, 0.06);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.stat-card:hover {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transform: translateY(-2px);
  border-color: rgba(242, 201, 76, 0.2);
}

.stat-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-value {
  font-size: 32px;
  font-weight: 800;
  color: #0F172A;
  line-height: 1;
  margin-bottom: 6px;
}

.stat-label {
  font-size: 13px;
  color: #94A3B8;
}

/* 图表区域 */
.charts-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.chart-card {
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius: 24px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(27, 60, 89, 0.06);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.chart-card:hover {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  border-color: rgba(242, 201, 76, 0.2);
}

.chart-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.chart-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0;
}

/* 统计列表 */
.stat-list {
  display: flex;
  flex-direction: column;
}

.stat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  border-bottom: 1px solid var(--color-border-light);
}

.stat-row:last-child {
  border-bottom: none;
}

.stat-row-label {
  font-size: 14px;
  color: var(--color-text-secondary);
}

.stat-row-value {
  font-size: 15px;
  font-weight: 600;
  color: var(--color-text);
}

@media (max-width: 900px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .charts-grid {
    grid-template-columns: 1fr;
  }
}
</style>
